var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"isActive":_vm.loading}}),_c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":_vm.descPlural}},[_c('ListaParametros',{attrs:{"url":"/admin/parametros","descPlural":_vm.descPlural,"descSingular":_vm.descSingular}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }